/* eslint-disable */
import React from 'react';
import _ from 'lodash';

export const pt = (mm: any) => `${mm * 2.834646}pt`;
export const mm = (vMm: any) => `${vMm * 1}mm`;

export const getNodes = (children: any = [], renderProps: any = {}): any => {
  const ret = children;
  if (_.isFunction(ret)) {
    return getNodes(ret(renderProps));
  }
  if (!_.isArray(ret)) {
    if (ret.type === React.Fragment) {
      return getNodes(ret.props.children);
    }
    return [ret];
  }
  return _.flattenDeep(_.map(ret, x => getNodes(x)));
};

export const getCssLengths = (lengthsStr: any) => {
  // eslint-disable-next-line prefer-const
  let [t, r, b, l] = lengthsStr.split(' ');
  const u = _.isUndefined;
  if (u(r)) {
    r = t;
    b = t;
    l = t;
  }
  if (u(b)) {
    b = t;
  }
  if (u(l)) {
    l = r;
  }
  return [t, r, b, l];
};
